import React from 'react';
import { Icon, IconName } from '@medely/ui-kit';

const getPlatformIcon = (name: IconName, color: string, size = 20) => (
  <Icon name={name} iconSize={`${size}px`} color={color} variant="custom" />
);

export const getNextStepsIcons = () => ({
  triangleExclamation: getPlatformIcon('exclamation-triangle', '#952A1F'),
  calendarDay: getPlatformIcon('light-calendar-day', '#fff'),
  lightbulbExclamationOn: getPlatformIcon('light-lightbulb-exclamation-on', '#fff'),
  location: getPlatformIcon('light-location-dot', '#fff'),
  locationCrosshairs: getPlatformIcon('location-crosshairs', '#fff'),
  fileInvoiceDollar: getPlatformIcon('circle-dollar-to-slot', '#172B4D'),
  award: getPlatformIcon('award', '#fff'),
  unlock: getPlatformIcon('unlock', '#fff'),
  usersMedical: getPlatformIcon('users-medical', '#3E3E83'),
});
